import { render, staticRenderFns } from "./SpotsSites.vue?vue&type=template&id=1ccea44b&scoped=true&"
import script from "./SpotsSites.vue?vue&type=script&lang=js&"
export * from "./SpotsSites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccea44b",
  null
  
)

export default component.exports